module.exports = __webpack_public_path__ + "static/media/skill.eb8966e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tocollege/skill.png
// module id = 226
// module chunks = 0